import { TextField } from '@biq/apex-ui';
import { Grid } from '@mui/material';
import { walletsAndGroupsCommonStyles } from 'pages/wallets-and-groups/wallets-and-groups-helper';
import React from 'react';
import { Controller } from 'react-hook-form';

interface DescriptionTextFieldProps {
    control: any;
    rows: number;
    error: any;
    required: boolean;
    onChange?: () => void;
}

export const DescriptionTextField = ({
    control,
    rows,
    error,
    required = false,
    onChange,
}: DescriptionTextFieldProps): React.JSX.Element => {
    return (
        <Grid sx={walletsAndGroupsCommonStyles.gridStyles}>
            <Controller
                name='description'
                control={control}
                render={({ field }): React.JSX.Element => (
                    <TextField
                        {...field}
                        variant='outlined'
                        label='Description'
                        multiline
                        rows={rows}
                        required={required}
                        error={!!error}
                        errorText={error ? error.message : ''}
                        onChange={(value): void => {
                            field.onChange(value);
                            onChange?.();
                        }}
                    />
                )}
            />
        </Grid>
    );
};
